import { GetServerSideProps, NextPage } from 'next';
import Link from 'next/link';
import Layout from '@lib/view/components/layout';
import APP_CONFIG from '@constants/APP_CONFIG';

const { EMAIL_CONTACT } = APP_CONFIG;

const TermAndConditionsVM: NextPage<{}> = () => {
    return (
        <Layout className={''} classHeader="header-shadow">
            <div className="md:container md:mx-auto px-4 md:px-35px mx-auto pt-10 pb-4 mb-10 border border-t-0">
                <div className="md:container md:mx-auto">
                    <div className="border-rouded">
                        <h1 className="font-bold text-2xl md:text-30px mb-4 text-green-cyprus">
                            Privacy policy
                        </h1>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Introduction
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - At Ignite ROI Co., Ltd, we prioritize the
                                    protection of your privacy and personal
                                    information. This privacy policy
                                    (&quot;policy&quot;) outlines our practices
                                    for collecting, using, and disclosing your
                                    personal information when you visit or use
                                    our website{' '}
                                    <Link href="/">
                                        <a>{APP_CONFIG.SITE_URL}</a>
                                    </Link>{' '}
                                    (the &quot;website&quot;).
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Information We Collect
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    1. We may collect the following types of
                                    personal information:
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - Contact details, such as your name, email
                                    address, and telephone number
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - Financial data, like your payment
                                    information and billing details
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - Usage information, including the pages you
                                    visit and the links you click on our website
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - Information you provide to us through
                                    customer support or other communications
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    2. We may also collect data using cookies,
                                    web beacons, and similar technologies. These
                                    tools help us understand how you use the
                                    website and enhance your experience. You can
                                    manage the use of cookies through your
                                    browser settings.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                How We Use Your Information
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    1. We may use your personal information for
                                    the following purposes:
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - To deliver the services and information
                                    you request
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - To process your payment and billing
                                    information
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - To address your inquiries and concerns
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - To enhance the website and our services
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - To send you marketing and promotional
                                    materials, if you have opted to receive them
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    2. We will not share your personal
                                    information with any third party for their
                                    own marketing or promotional purposes
                                    without your explicit consent.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Data Retention
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - We will retain your personal information
                                    for as long as necessary to provide the
                                    services and information you request, or as
                                    required by law.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Data security
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - We implement reasonable measures to
                                    safeguard your personal information from
                                    unauthorized access, use, disclosure,
                                    alteration, or destruction. However, please
                                    note that no method of internet transmission
                                    or electronic storage is completely secure.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Changes to This Policy
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - We may update this policy periodically. If
                                    changes occur, we will notify you by sending
                                    an email or posting a notice on the website.
                                    Your continued use of the website following
                                    the posting of changes to this policy
                                    indicates your acceptance of the changes.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4" id="term">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Contact us
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - If you have any questions or concerns
                                    regarding this policy or the website, please
                                    contact us at{' '}
                                    <a href="mailto:info@igniteroi.com">
                                        info@igniteroi.com
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4" id="refund">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Conclusion
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    By using the website, you consent to the
                                    collection, use, and disclosure of your
                                    personal information as described in this
                                    policy. If you do not agree with this
                                    policy, you must not use the website.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default TermAndConditionsVM;

export const getServerSideProps: GetServerSideProps = async (): Promise<{
    props: { title: string };
}> => {
    return {
        props: {
            title: 'T&C & Refund Policy',
        },
    };
};
